
const SheetIcon = ({ color}) => {


  const desktopviewBox = "-10 -5 50 30";
  return (
    <svg
      id="Icono_ver_ficha"
      data-name="Icono ver ficha"
      xmlns="http://www.w3.org/2000/svg"
      viewBox={desktopviewBox}
    >
      <path
        fill={color}
        d="m16.81,10.66V1.05c0-.58-.47-1.05-1.05-1.05H6.09c-.29,0-.57.12-.77.34L.28,5.82c-.18.19-.28.45-.28.71v14.28c0,.58.47,1.05,1.05,1.05h10.1c1.2,1.22,2.87,1.97,4.71,1.97,3.65,0,6.62-2.97,6.62-6.62,0-3.33-2.47-6.09-5.68-6.55ZM5.36,3.39v2.36h-2.17l2.17-2.36Zm3.88,13.81c0,.9.18,1.77.51,2.55H2.1V7.26h4.01c.41,0,.75-.34.75-.75V2.1h7.85v8.59c-3.1.55-5.47,3.26-5.47,6.52Zm6.62,4.53c-2.5,0-4.53-2.03-4.53-4.53s2.03-4.53,4.53-4.53,4.53,2.03,4.53,4.53-2.03,4.53-4.53,4.53Z"
      />
      <path
        fill={color}
        d="m6.53,12.81h-1.82c-.35,0-.64.34-.64.75s.29.75.64.75h1.82c.35,0,.64-.34.64-.75s-.29-.75-.64-.75Z"
      />
      <path
        fill={color}
        d="m6.53,16.41h-1.82c-.35,0-.64.34-.64.75s.29.75.64.75h1.82c.35,0,.64-.34.64-.75s-.29-.75-.64-.75Z"
      />
      <path
        fill={color}
        d="m4.65,10.51h5.5c.41,0,.75-.34.75-.75s-.34-.75-.75-.75h-5.5c-.41,0-.75.34-.75.75s.34.75.75.75Z"
      />
      <circle fill={color} cx="15.86" cy="14.9" r=".75" />
      <path
        fill={color}
        d="m16.61,19.82v-2.82c0-.35-.34-.64-.75-.64s-.75.29-.75.64v2.82c0,.35.34.64.75.64s.75-.29.75-.64Z"
      />
    </svg>
  );
};

export default SheetIcon;
